module.exports = __webpack_public_path__ + "img/ios-title.019c682e.png";